// Helpers for topic filters
import moment from 'moment'

import * as f from './Filters'
import * as TLM from '../constants/tlm'
import { TOPIC_SUBTYPES, MEDIA_PREFERENCE_SUBTYPES } from '../constants/commons'

const TopicSubTypes = TOPIC_SUBTYPES.split(' ')
export const DefaultFilters = TopicSubTypes.map(subType => new f.Filter({
  topic_sub_type: subType
}))

const MediaPrefTopicSubTypes = MEDIA_PREFERENCE_SUBTYPES.split(' ')
export const MediaPrefrence = new f.Filters(MediaPrefTopicSubTypes.map(subType => new f.Filter({
  topic_sub_type: subType
})))
//'Movie Show People Brand Music Lifestyle Channel Gaming'
export const MediaPrefrenceActive = new f.Filters([
  new f.Filter({ topic_sub_type: TLM.PEOPLE }),
  new f.Filter({ topic_sub_type: TLM.BRAND }),
  new f.Filter({ topic_sub_type: TLM.MUSIC }),
  new f.Filter({ topic_sub_type: TLM.LIFESTYLE }),
  new f.Filter({ topic_sub_type: TLM.CHANNEL }),
  new f.Filter({ topic_sub_type: TLM.GAMING }),
  new f.Filter({ topic_sub_type: TLM.MOVIE, labels_not: 'Cancelled',
    date_range: new f.FilterDateRange({
      start_date: moment().subtract(2, 'years').format('YYYY-MM-DD')
    }) }),
  new f.Filter({ topic_sub_type: TLM.SHOW, labels_not: 'Cancelled',
    date_range: new f.FilterDateRange({
      start_date: moment().subtract(2, 'years').format('YYYY-MM-DD')
    }) }),
  new f.Filter({
    topic_sub_type: TLM.SHOW,
    labels_or: 'Special',
    date_range: new f.FilterDateRange({
      start_date: moment().subtract(1, 'years').format('YYYY-MM-DD')
    })
  }),
  new f.Filter({
    topic_sub_type: TLM.MOVIE,
    labels_or: 'Special',
    date_range: new f.FilterDateRange({
      start_date: moment().subtract(1, 'years').format('YYYY-MM-DD')
    })
  }),
  new f.Filter({
    topic_sub_type: TLM.SHOW,
    labels_or: 'Sports',
    date_range: new f.FilterDateRange({
      start_date: moment().subtract(2, 'years').format('YYYY-MM-DD')
    })
  }),
  new f.Filter({
    topic_sub_type: TLM.MOVIE,
    labels_or: 'Sports',
    date_range: new f.FilterDateRange({
      start_date: moment().subtract(2, 'years').format('YYYY-MM-DD')
    })
  })
])

export const PlanFilters = {
  Shows: new f.Filter({
    topic_sub_type: TLM.SHOW
  }),
  Lifestyle: new f.Filters([new f.Filter({
    topic_sub_type: TLM.LIFESTYLE
  })]),
  Brand: new f.Filters([new f.Filter({
    topic_sub_type: TLM.BRAND
  })]),
  Video: [new f.Filter({
    topic_sub_type: TLM.VIDEO
  })],
  Anticipation: [
    new f.Filter({
      topic_sub_type: 'Show',
      date_range: new f.FilterDateRange({
        start_date: moment(new Date()).format('YYYY-MM-DD')
      })
    }),
    new f.Filter({
      topic_sub_type: 'Movie',
      date_range: new f.FilterDateRange({
        start_date: moment(new Date()).format('YYYY-MM-DD')
      })
    }),
    new f.Filter({
      topic_sub_type: 'Video',
      topic_name_match: f.ANTICIPATION_VIDEO_REGEX
    })
  ],
  Genre: {
    ActionAndAdventure: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Action and Adventure'
    }),
    Comedy: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Comedy'
    }),
    CrimeDrama: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Crime Drama'
    }),
    Documentary: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Documentary'
    }),
    Docuseries: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Docuseries'
    }),
    Drama: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Drama'
    }),
    GameShow: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Game Show'
    }),
    Lifestyle: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Lifestyle'
    }),
    News: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'News'
    }),
    Procedural: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Procedural'
    }),
    Reality: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Reality'
    }),
    RealityCompetition: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Reality Competition'
    }),
    ScienceFiction: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Science Fiction'
    }),
    Sitcom: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Sitcom'
    }),
    SpanishLanguage: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Spanish Language'
    }),
    Special: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Special'
    }),
    Sports: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Sports'
    }),
    Talk: new f.Filter({
      topic_sub_type: TLM.SHOW,
      labels_or: 'Talk'
    })
  },
  Brands: {
    Airline: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'Airline'
    }),
    Appliances: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Appliances', 'Applicances']
    }),
    Automotive: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Auto', 'Car Rental', 'Gas Station']
    }),
    BabyAndKids: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Toys', 'CPG - Baby']
    }),
    CPG: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['CPG - Alcohol', 'CPG - AlcoholBeer', 'CPG - Baby', 'CPG - Batteries', 'CPG - Beauty', 'CPG - Beverage', 'CPG - Candy', 'CPG - Condiments', 'CPG - Food', 'CPG - FoodChips', 'CPG - Home', 'CPG - Hygiene', 'CPG - Laundry', 'CPG - Medicine', 'CPG - Office', 'CPG - Outdoor', 'CPG - Personal Care', 'CPG - Pet', 'CPG - Skin Care']
    }),
    CPGAlcohol: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['CPG - Alcohol']
    }),
    CPGBeauty: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['CPG - Beauty']
    }),
    CPGBeverage: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['CPG - Beverage']
    }),
    CPGCandyAndGum: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['CPG - Candy', 'Gum']
    }),
    CPGFood: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['CPG - Foods', 'CPG - Condiments']
    }),
    CPGHomeAndLaundry: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['CPG - Home', 'CPG - Laundry']
    }),
    CPGPersonalCare: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['CPG - Personal Care']
    }),
    CPGPetCare: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'CPG - Pet'
    }),
    Finance: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Banking', 'Financial', 'Credit Card']
    }),
    Fitness: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'Fitness'
    }),
    Gaming: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Video Game', 'Online Games']
    }),
    Hotel: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'Hotel'
    }),
    Insurance: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'Insurance'
    }),
    MediaAndNews: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Magazine', 'Periodical', 'Radio', 'Online Video']
    }),
    Pharmaceuticals: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'CPG - Medicine'
    }),
    Podcasts: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'Podcast'
    }),
    QSR: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'QSR'
    }),
    Restaurant: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'Restaurant'
    }),
    Retail: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Retailers', 'Clothing', 'Jewelry', 'Power Tools', 'Flowers']
    }),
    Services: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Service', 'Storage', 'Online Dating', 'Logistics', 'Diet']
    }),
    Technology: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Computers', 'Media', 'NonProfit', 'Photography', 'Software', 'Streaming Service', 'Tech']
    }),
    Telecommunication: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Telecommunications']
    }),
    Travel: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Online Travel', 'Travel']
    }),
    Entertainment: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Book', 'Entertainment', 'Media Company', 'Movie Studio', 'Streaming Service']
    }),
    Industrial: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: ['Energy', 'Manufacturing']
    }),
    RealEstate: new f.Filter({
      topic_sub_type: TLM.BRAND,
      labels_or: 'Real Estate'
    })
  }
}
